import React from 'react';
import { Button, FormGroup } from 'reactstrap';
import { compose, withHandlers, withState } from 'recompose';
import { isFunction, isObject, omit } from 'lodash';
import moment from 'moment';
import { NotificationManager } from 'react-notifications';

export const TableCSVExport = ({ onButtonClick, isExporting, ...props }) => (
  <FormGroup {...props} className="table-csv-export clearfix">
    <Button className="pull-right" color="primary" onClick={onButtonClick} disabled={isExporting}>
      {isExporting ? 'Exporting...' : 'Export CSV'}
    </Button>
  </FormGroup>
);

const enhance = compose(
  withState('isExporting', 'setIsExporting', false),
  withHandlers({
    onButtonClick: ({
      ordering: tmpOrdering,
      filters,
      search,
      url,
      client,
      filename,
      setIsExporting,
    }) => async () => {
      setIsExporting(true);

      let params = { search, format: 'csv' };
      if (isObject(filters)) {
        params = {
          ...params,
          ...filters,
        };
      }
      NotificationManager.info('Exporting CSV...', 'Export CSV', 0);

      params = omit(params, ['offset', 'limit']);
      try {
        const response = await client.get(url, { params });
        const csvData = response.data;
        NotificationManager.listNotify.forEach(n => NotificationManager.remove({ id: n.id }));

        NotificationManager.success('CSV exported successfully', 'Export CSV', 3000);

        const link = document.createElement('a');
        const universalBOM = "\uFEFF";

        const downloadFilename = isFunction(filename)
          ? filename(moment().format('YYYY-MM-DD_HH-mm'))
          : filename;

        link.href = 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + csvData);
        link.download = downloadFilename;
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        NotificationManager.error('CSV export failed', 'Export CSV', 3000);
        console.error("CSV export failed:", error);
      } finally {
        setIsExporting(false);
      }
    },
  }),
);

export default enhance(TableCSVExport);



// WEBPACK FOOTER //
// ./src/components/common/Tables/TableCSVExport.jsx